import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getWorkspaceTeammate } from 'Shared/selectors/workspace';
import { useResendInvite } from 'Shared/actions/inviteToWorkspace';
import { WpButton, Size, Variant } from 'Wpds/components/button';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';
import { User } from 'Shared/constants/types';

type Props = {
  size?: Size;
  variant?: Variant;
  onClick?: Function;
};

export default function ResendInviteButton({ onClick, size, variant = 'primary' }: Props) {
  const { workspace } = useWorkspace();
  const teammate: User = useSelector(getWorkspaceTeammate(workspace.id));

  const [resendInvite, { loading }] = useResendInvite();

  const handleClick = useCallback(async () => {
    if (onClick) {
      onClick();
    }
    return resendInvite({
      workspaceId: workspace.id,
      userId: teammate.id,
    });
  }, [resendInvite, teammate.id, workspace.id]);

  return (
    <WpButton onClick={handleClick} loading={loading} size={size} variant={variant}>
      Resend Invite
    </WpButton>
  );
}
